/* =========================================================
   VISIONE INCISA — visione-incisa.js
   Un solo file per tutti gli script. Va caricato da theme.liquid.
   Funziona anche se una sezione non è presente nella pagina.
   ========================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---------- Header: ombra quando è agganciato in alto ---------- */
  function initHeader() {
    var head = document.getElementById('viHead');
    if (!head) return;
    var onScroll = function () {
      head.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Carrello: contatore dell'header personalizzato ---------- */
  function setCartCount(count) {
    var safeCount = Math.max(0, Number(count) || 0);

    document.querySelectorAll('.vi-head__count').forEach(function (badge) {
      badge.dataset.count = String(safeCount);
      badge.textContent = safeCount > 99 ? '99+' : String(safeCount);
    });
  }

  function fetchCartCount() {
    var cartUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';

    return fetch(cartUrl + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Impossibile aggiornare il contatore del carrello');
        return response.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
      })
      .catch(function () {
        // Il conteggio Liquid gia mostrato rimane come riserva.
      });
  }

  function initCartCount() {
    if (document.documentElement.dataset.viCartCountReady === 'true') return;
    document.documentElement.dataset.viCartCountReady = 'true';

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!event.promise || typeof event.promise.then !== 'function') {
        fetchCartCount();
        return;
      }

      event.promise
        .then(function (result) {
          var total = result && result.cart && result.cart.totalQuantity;
          if (Number.isFinite(total)) setCartCount(total);
          else fetchCartCount();

          /* Dopo un'aggiunta riuscita apre la pagina carrello completa,
             senza mostrare il carrello laterale del tema. */
          var didError = result && result.detail && result.detail.didError;
          if (event.action === 'add' && !didError) {
            var cartUrl = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
            window.location.assign(cartUrl);
          }
        })
        .catch(function () {
          // Gli errori di aggiunta sono gia gestiti dal form prodotto.
        });
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) fetchCartCount();
    });
  }

  /* ---------- Menu mobile ---------- */
  function initDrawer() {
    var drawer = document.getElementById('viDrawer');
    var burger = document.getElementById('viBurger');
    if (!drawer || !burger) return;

    var panel = drawer.querySelector('.vi-drawer__panel');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = panel.querySelector('a, button');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    burger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? close() : open();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-vi-close]') ||
          e.target.classList.contains('vi-drawer__scrim')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Ricerca a scomparsa ---------- */
  function initSearch() {
    var toggle = document.getElementById('viSearchBtn');
    var box = document.getElementById('viSearch');
    if (!toggle || !box) return;

    toggle.addEventListener('click', function () {
      var isOpen = box.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var input = box.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 120);
      }
    });
  }

  /* ---------- Ticker ---------- */
  function initTicker() {
    var items = document.querySelectorAll('.vi-ticker__i');
    if (items.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3800);
  }

  /* ---------- Hero: passata del laser ---------- */
  function initHero() {
    var hero = document.getElementById('viHero');
    if (!hero) return;
    requestAnimationFrame(function () { hero.classList.add('is-ready'); });
  }

  /* ---------- Rivelazione allo scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.vi-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Barra acquisto fissa (pagina prodotto) ---------- */
  function initSticky() {
    var bar = document.getElementById('viSticky');
    if (!bar) return;

    var btn = document.getElementById('viStickyBtn');
    var form = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');

    if (btn) {
      btn.addEventListener('click', function () {
        var target = document.querySelector(
          'input[type="file"], .product-form__input, product-form, form[action*="/cart/add"]'
        );
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    if (!form || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(form);
  }

  function boot() {
    initHeader();
    initCartCount();
    initDrawer();
    initSearch();
    initTicker();
    initHero();
    initReveal();
    initSticky();
  }

  ready(boot);

  /* L'editor del tema ricarica le sezioni: riattacca tutto */
  document.addEventListener('shopify:section:load', boot);
})();
